import React from "react"
import TopTitle from "@components/TopTitle"
import Wrapper from "@components/Wrapper"
import styles from "./SectionOne.module.scss"
import RiskGraphic from "./RiskFree.png";
import HelpGraphic from "./HowWeHelp.png";
import PersonalSecret from "./PersonalSecret.png";
import AccessSecret from "./AccessSecret.png";
import ShareIcon from "./ShareIcon.png";
import SharedPassword from "./SharedPassword.png";
import SharedSecrets from "./SharedSecrets.png";
import { OutboundLink } from '@assertiv/assertiv-gatsby-plugin-google-gtag'


export default class SectionOne extends React.Component {

    render() {
        return (
            <section className="container-fluid bg-xl-light-gray">
                <div className="row ml-0 mr-0">
                    <Wrapper className={"w-100 text-left"} gap="outer">
                        <div className="row bg-white justify-content-center pt-10">
                            <div className={"col-auto col-lg-10 m-lg-2 " + styles.contactParent}>
                                <TopTitle content="How can we help?" />
                                <div className={ styles.topTextBody + " col-12"}>
                                    <img alt="EngineID SSO Help" className={styles.tabletRightImage} src={HelpGraphic} />
                                    <p>
                                        In a business with a range of different types of employees, people will keep track of their different passwords in vastly different ways. Here are some examples:
                                    </p>
                                    <p>
                                        <ul>
                                            <li>Reusing the same password on multiple systems and committing it to memory.</li>
                                            <li>Passwords written down on a notepad.</li>
                                            <li>A spreadsheet on an employees PC containing passwords.</li>
                                        </ul>
                                    </p>
                                    <p>
                                        None of these methods are secure. Here’s why:
                                    </p>
                                    <p>
                                        <ul>
                                            <li>Reusing a password between systems risks all of your applications if one suffers an attack.</li>
                                            <li>Passers-by can easily see written down passwords. This offers little in terms of security.</li>
                                            <li>Spreadsheets containing passwords are dangerous in the wrong hands. Furthermore, a hacker will also make short work of a spreadsheet even if it is password protected.</li>
                                        </ul>
                                    </p>
                                </div>
                            </div>
                            <div className={"col-auto col-lg-10 m-lg-2 pt-10 " + styles.contactParent}>
                                <TopTitle content="Personal Passwords" />
                                <div className={ styles.topTextBody + " col-12"}>
                                    <div className={ "w-100" }>
                                        <p>
                                            EngineID allows users to store passwords on their personal EngineID account which only they can see. What’s more, EngineID encrypts all passwords before 
                                            saving them. This increases the security of the system.
                                        </p>
                                        <p>
                                            Personal passwords allows optional attachment to Bookmarks displayed on your app dashboard. Your login details stay conveniently close to websites when 
                                            you want to log in.
                                        </p>
                                    </div>
                                    <div className={ styles.demoMiddle + " w-100" }>
                                        <img alt="Personal Password" src={PersonalSecret} className={styles.demoImage} />
                                    </div>
                                    <div className={ "w-100" }>
                                        <p>
                                            You can view, update or copy passwords to easily sign into web applications.
                                        </p>
                                    </div>
                                    <div className={ styles.demoMiddle + " w-100" }>
                                        <img alt="Access Personal Password" src={AccessSecret} className={styles.demoImage} />
                                    </div>
                                </div>
                            </div>
                            <div className={"col-auto col-lg-10 m-lg-2 pt-10 " + styles.contactParent}>
                                <TopTitle content="Sharing Passwords" />
                                <div className={ styles.topTextBody + " col-12"}>
                                    <div className={ "w-100" }>
                                        <p>
                                            An exciting new feature in EngineID is the ability to share passwords with others. This is particularly useful when multiple people share an 
                                            account in an application and need a more secure method to store the username and password.
                                        </p>
                                        <p>
                                            If you share a password, you have the option to share it in a ‘read only’ mode, or you can allow people to modify the password if you wish.
                                        </p>
                                        <p>
                                            Shared passwords can be attached to applications in the Application Launch Dashboard and will display with a different icon (<img alt="Personal Password" src={ShareIcon} />).
                                        </p>
                                    </div>
                                    <div className={ styles.demoMiddle + " w-100" }>
                                        <img alt="Personal Password" src={SharedPassword} className={styles.demoImage} />
                                    </div>
                                    <div className={ "w-100" }>
                                        <p>
                                            EngineID encrypts Shared Passwords, similarly to Personal Passwords. This provides the following benefits:
                                        </p>
                                        <p>
                                            <ul>
                                                <li>Communication of passwords is secure.</li>
                                                <li>It provides a single, safe place to maintain the password if it needs to change in the future.</li>
                                            </ul>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className={"col-auto col-lg-10 m-lg-2 pt-10 " + styles.contactParent}>
                                <TopTitle content="Manage Passwords Easily" />
                                <div className={ styles.topTextBody + " col-12"}>
                                    <div className={ "w-100" }>
                                        <p>
                                            “My Passwords” in EngineID lists all the Passwords that you have permission to see. Both Personal and Shared Passwords are shown, with Shared 
                                            Passwords identified with the <img alt="Personal Password" src={ShareIcon} /> icon next to the name.
                                        </p>
                                    </div>
                                    <div className={ styles.demoMiddle + " w-100" }>
                                        <img alt="Password Management" src={SharedSecrets} className={styles.demoImage} />
                                    </div>
                                    <div className={ "w-100" }>
                                        <p>
                                            Clicking on a Password in the list allows you to view the Password, or modify it (if you have permission to do so).
                                        </p>

                                    </div>
                                </div>
                            </div>
                            <div className={"col-auto col-lg-10 m-lg-2 pt-10 " + styles.contactParent}>
                                <TopTitle content="Security Tip" />
                                <div className={ styles.topTextBody + " col-12"}>
                                    <div className={ "w-100" }>
                                        <p>
                                            It’s important to keep your EngineID account safe. We highly recommend enabling Multi Factor Authentication since this 
                                            significantly reduces the chance of your account being broken into.
                                        </p>
                                        <p>
                                            We recommend setting a strong, unique password on your EngineID account. For easy and secure login, use Passwordless login. 
                                            Passwordless allows you to log into EngineID with a trusted device, like your mobile phone.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row bg-white justify-content-end pl-6 pr-6 pt-10">
                            <div className={"col-auto col-lg-5 m-lg-2 " + styles.contactParent}>
                                <TopTitle content="Why use EngineID?" />
                                <div className={styles.contactRow + " row bg-white"}>
                                    <div className={ styles.topTextBody + " col-12"}>
                                        <p>
                                            EngineID has been specializing in Identity Security and Authentication solutions since 2016. Our feature rich platform solves a wide range of complex challenges, 
                                            with Passwords Management a core component of what we do.
                                        </p>
                                        <p>
                                            When you use EngineID, you receive many benefits:
                                        </p>
                                        <p>
                                            <ul>
                                                <li>An expert team of Identity and Authentication specialists and developers. Our focus is on solving complex challenges such as consolidation of diverse application landscapes.</li>
                                                <li>No computer servers required. Connect to our cloud hosted solution to use EngineID immediately.</li>
                                                <li>Ongoing support and enhancements of our solution. As a cloud product, we handle all maintenance.</li>
                                                <li>Ongoing testing of our solution improves confidence of a secure solution.</li>
                                                <li>Highly scalable solution to cater for any number of users.</li>
                                                <li>EngineID is not limited to Passwords Management. There is a <OutboundLink href="../features">long list</OutboundLink> of included features you get at no additional cost.</li>
                                            </ul>
                                        </p>
                                        <p>
                                            Access Management is important to get right. Let EngineID up-lift your access strategy with confidence. In fact, we’re so confident in the EngineID product that we offer
                                            a <OutboundLink href="https://app.engineid.com/register">free plan</OutboundLink> that you can use right away.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className={"col-lg-6 " + styles.tabletParent}>
                                <div className={styles.tablet}>
                                    <img alt="EngineID OpenID Connect" className={styles.tabletImage} src={RiskGraphic} />
                                </div>
                            </div>
                        </div>
                    </Wrapper>
                </div>
            </section>
        );
    }
}